import { IReleasable } from '@/webgl/core/IReleasable'
import Signal from '@/webgl/core/Signal'
import { CollectibleEntity } from '@/webgl/runner/entities/CollectibleEntity'
import { StatusType } from '@/webgl/runner/rendering/PlayerStatusRenderer'

export type PlayerInputEvent = {
  direction: number
}

export type SpawnCollectibleEvent = {
  id: string
  lane: number
  offset?: number
  entity?: CollectibleEntity
  priceID?: number
}

export type CollectEvent = {
  isGoal: boolean
  collectible: CollectibleEntity
}

export default class GameEvents {
  public GameDispose = new Signal<void>()
  public PlayerInput = new Signal<PlayerInputEvent>()

  public SpawnCollectible = new Signal<SpawnCollectibleEvent>()
  public CollectibleGrabbed = new Signal<CollectibleEntity>()
  public CollectibleMissed = new Signal<CollectibleEntity>()
  public PlayCollect = new Signal<CollectEvent>()
  public GamePause = new Signal<void>()
  public GameResume = new Signal<void>()
  public StatusTrigger = new Signal<StatusType>()

  _events: IReleasable[] = []

  constructor() {
    this._events = [
      this.PlayerInput,
      this.SpawnCollectible,
      this.CollectibleGrabbed,
      this.CollectibleMissed,
      this.PlayCollect,
      this.GamePause,
      this.GameResume,
      this.StatusTrigger,
      this.GameDispose,
    ]
  }

  public dispose() {
    this.GameDispose.emit()
    this._events.forEach((e) => e.release())
    this._events = []
  }
}
